import api from './client';

export const categoriesApi = {
  getAll: () => api.get('/categories'),
  getNavTree: () => api.get('/categories/nav-tree'),
  getOne: (categoryId) => api.get(`/categories/${categoryId}`),
  create: (data) => api.post('/categories', data),
  update: (categoryId, data) => api.put(`/categories/${categoryId}`, data),
  delete: (categoryId) => api.delete(`/categories/${categoryId}`),
  seed: () => api.post('/categories/seed'),
  syncNavDefaults: () => api.post('/categories/sync-nav-defaults'),
};
